







import { Component, Vue } from 'vue-property-decorator';
import Colors from '@/components/Colors.vue'; // @ is an alias to /src
import Typography from '@/components/Typography.vue'; // @ is an alias to /src

@Component({
  components: {
    Colors,
    Typography,
  },
})
export default class Design extends Vue {}
